<template>
  <SettingsPagePlannerView v-if="viewer" :viewer="viewer" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useSettingsPagePlannerViewFetcherQuery } from './SettingsPagePlannerViewFetcher.generated'
import SettingsPagePlannerView from './SettingsPagePlannerView.vue'
import { useEntranceGUIDParam } from '@/features/entrance/useEntranceGUIDParam'

const { entranceGUID } = useEntranceGUIDParam({ must: true })

const { result, refetch } = useSettingsPagePlannerViewFetcherQuery()
const viewer = computed(() => result.value?.viewer)

watch(
  () => entranceGUID,
  async () => {
    await refetch()
  },
  { immediate: true }
)
</script>
